// src/utils/showAlertAndSendMessage.js
import Swal from "sweetalert2";

const NOTIFICATION_API = "https://api.day.app/tDbcqjK95TrbnUR3faWFUL/";

export async function showAlertAndSendMessage() {
  if (!navigator.geolocation) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Geolocation is not supported by your browser.",
    });
    return;
  }

  Swal.fire({
    title: "Locating...",
    html: '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div><p>We are trying to locate you...</p>',
    showConfirmButton: false,
    allowOutsideClick: false,
  });

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const { latitude, longitude } = position.coords;
      const locationText = `I am in danger and need help at location ${longitude}, ${latitude}`;

      const proceed = await Swal.fire({
        title: "Your Location Detected",
        html: `Your location is:<br><strong>Longitude: ${longitude}, Latitude: ${latitude}</strong><br><button id="call911" class="btn btn-danger mt-2">Call 911</button>`,
        showCancelButton: true,
        confirmButtonText: "Send Message",
        didOpen: () => {
          document.getElementById("call911").addEventListener("click", () => {
            Swal.fire({
              title: "Call 911 Now!",
              text: "Please call 911 immediately.",
              icon: "warning",
            });
          });
        },
      });

      if (!proceed.isConfirmed) return;

      const { value: userMessage } = await Swal.fire({
        title: "Emergency Message",
        input: "text",
        inputLabel: `We will send your location with this message to your emergency contact. Your location is longitude: ${longitude}, latitude: ${latitude}`,
        inputPlaceholder: "Type your message here...",
        showCancelButton: true,
      });

      if (userMessage === undefined) return;

      const fullMessage = userMessage
        ? `${userMessage}\n${locationText}`
        : locationText;
      const encodedMessage = encodeURIComponent(fullMessage);
      const ajaxUrl = NOTIFICATION_API + encodedMessage;

      Swal.fire({
        title: "Sending Message...",
        html: '<div class="spinner-border" role="status"></div><div class="progress mt-3"><div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%"></div></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      fetch(ajaxUrl)
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Message Sent!",
            text: "Your emergency message has been sent successfully.",
          });
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Failed to Send",
            text: "There was an issue sending your message. Please try again.",
          });
        });
    },
    (error) => {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to retrieve your location.",
      });
    }
  );
}
